import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer>
      <section className="section section-copyright">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-5">
              <ul className="nav nav-copy">
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="https://globalct.com/impressum"
                  >
                    Impressum
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="https://globalct.com/datenschutz"
                  >
                    Datenschutz
                  </a>
                </li>
              </ul>
            </div>
            <div className="text-right col-md-7">
              <div className="meta meta-copyright">
                <span className="mb-0">
                  © Copyright 2015 - {`${new Date().getFullYear()}`} |
                  Global CT Services & Consulting GmbH
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
